export default {"src":"/_next/static/media/foot_ball.b55eda5e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};